import React from "react";
import { makeStyles, Typography, Grid } from "@material-ui/core";
import publicMainStyle from "assets/jss/components/publicMainStyles";
import { useTranslation } from "react-i18next";
import ContactSupport from "features/helpButton/components/ContactSupport";
import { useLocation } from "react-router";

const useStyles = makeStyles(publicMainStyle);

const PublicFooter = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isGdprConsent = pathname.includes("gdpr-consent");

  return (
    <Grid container className={classes.publicHeaderFooterGrid}>
      <Grid item xs container alignItems="center" className={classes.padding25}>
        <Typography variant="subtitle1" component="div" className={classes.title}>
          {t("PublicInfo.AnyQuestions")}
        </Typography>
        {isGdprConsent ? (
          <Typography variant="caption" component="div">
            {t("PublicInfo.QuestionsRegardingGdpr")}
          </Typography>
        ) : (
          <Typography variant="caption" component="div">
            {t("PublicInfo.QuestionsRegardingDocuments")}
          </Typography>
        )}

        <Typography variant="caption" component="div">
          {t("PublicInfo.FindDetailsOfContactPerson")}
        </Typography>
      </Grid>
      <Grid item xs>
        <ContactSupport />
      </Grid>
    </Grid>
  );
};

export default PublicFooter;
